// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/delivery_calendar_key.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/delivery_calendar_key.proto.
 */
export const file_bfftypes_v1_delivery_calendar_key: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ0eXBlcy92MS9kZWxpdmVyeV9jYWxlbmRhcl9rZXkucHJvdG8SC2JmZnR5cGVzLnYxKpQEChNEZWxpdmVyeUNhbGVuZGFyS2V5EiUKIURFTElWRVJZX0NBTEVOREFSX0tFWV9VTlNQRUNJRklFRBAAEiIKHkRFTElWRVJZX0NBTEVOREFSX0tFWV9IT0tLQUlETxABEiAKHERFTElWRVJZX0NBTEVOREFSX0tFWV9UT0hPS1UQAhIfChtERUxJVkVSWV9DQUxFTkRBUl9LRVlfVE9LWU8QAxIfChtERUxJVkVSWV9DQUxFTkRBUl9LRVlfQ0hVQlUQBBIiCh5ERUxJVkVSWV9DQUxFTkRBUl9LRVlfSE9LVVJJS1UQBRIgChxERUxJVkVSWV9DQUxFTkRBUl9LRVlfS0FOU0FJEAYSIQodREVMSVZFUllfQ0FMRU5EQVJfS0VZX0NIVUdPS1UQBxIhCh1ERUxJVkVSWV9DQUxFTkRBUl9LRVlfU0hJS09LVRAIEiAKHERFTElWRVJZX0NBTEVOREFSX0tFWV9LWVVTSFUQCRIhCh1ERUxJVkVSWV9DQUxFTkRBUl9LRVlfT0tJTkFXQRAKEh4KGkRFTElWRVJZX0NBTEVOREFSX0tFWV9KRVBYEAsSHwobREVMSVZFUllfQ0FMRU5EQVJfS0VZX1RPQ09NEAwSHQoZREVMSVZFUllfQ0FMRU5EQVJfS0VZX0VFWBANEh0KGURFTElWRVJZX0NBTEVOREFSX0tFWV9JQ0UQDkJCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * DeliveryCalendarKey は相対取引 leg の受給日カレンダー (固定 14 値)。
 * Mirrors backend types.v1.DeliveryCalendarKey 1:1 (wire 値も同一)。
 * Hosted under bfftypes/v1 for BFF-local reuse across service packages.
 *
 * @generated from enum bfftypes.v1.DeliveryCalendarKey
 */
export enum DeliveryCalendarKey {
  /**
   * @generated from enum value: DELIVERY_CALENDAR_KEY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 北海道エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * 東北エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * 東京エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * 中部エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * 北陸エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * 関西エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * 中国エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * 四国エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * 九州エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_KYUSHU = 9;
   */
  KYUSHU = 9,

  /**
   * 沖縄エリアカレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_OKINAWA = 10;
   */
  OKINAWA = 10,

  /**
   * JEPX 取引カレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_JEPX = 11;
   */
  JEPX = 11,

  /**
   * TOCOM 取引カレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_TOCOM = 12;
   */
  TOCOM = 12,

  /**
   * EEX 取引カレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_EEX = 13;
   */
  EEX = 13,

  /**
   * ICE 取引カレンダー。
   *
   * @generated from enum value: DELIVERY_CALENDAR_KEY_ICE = 14;
   */
  ICE = 14,
}

/**
 * Describes the enum bfftypes.v1.DeliveryCalendarKey.
 */
export const DeliveryCalendarKeySchema: GenEnum<DeliveryCalendarKey> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_delivery_calendar_key, 0);

